import { useState } from "react";
import { LocationAutocomplete } from "./ActivityForm";
import { LodgingPoint } from "./plannerTypes";

interface Props {
  day: number; // 0-based
  initial?: LodgingPoint; // current per-day override, if any
  baseLabel: string; // trip base, shown as the fallback
  onSave: (point: LodgingPoint) => void; // set a per-day override
  onUseBase: () => void; // clear override -> fall back to trip base
  onCancel: () => void;
}

// Small modal body for setting where you're staying on a given day (overrides
// the trip's base accommodation). Used for the per-day Restid calculation.
export const LodgingEditor = ({ day, initial, baseLabel, onSave, onUseBase, onCancel }: Props) => {
  const [point, setPoint] = useState<LodgingPoint>(
    initial ?? { location: "", lat: null, lng: null }
  );

  return (
    <div className="planner__picker">
      <h3 className="planner__picker-title">🏨 Boende — Dag {day + 1}</h3>
      <LocationAutocomplete
        value={point.location}
        hasCoords={point.lat !== null}
        placeholder="Var bor ni denna natt?"
        onText={(t) => setPoint({ location: t, lat: null, lng: null })}
        onPick={(r) => setPoint({ location: r.label, lat: r.lat, lng: r.lng })}
      />
      {baseLabel && (
        <p className="planner__day-hint">
          Lämna tomt för att använda resans basboende{baseLabel ? `: ${baseLabel}` : ""}.
        </p>
      )}
      <div className="planner__form-actions">
        {initial && (
          <button type="button" className="planner__btn planner__btn--ghost" onClick={onUseBase}>
            Använd basboende
          </button>
        )}
        <button type="button" className="planner__btn planner__btn--ghost" onClick={onCancel}>
          Avbryt
        </button>
        <button
          type="button"
          className="planner__btn"
          disabled={point.lat === null}
          onClick={() => onSave(point)}
        >
          Spara
        </button>
      </div>
    </div>
  );
};
